module.exports = __webpack_public_path__ + "media/images/top/works03-1e71b49ce861783f5a05fd4bc11f5c7b.jpg";